export default {
  cardHeaderFontSize: '1.5rem',
  cardDataFontSize: '1rem',
  cardColor: 'var(--digi-blue-700)',
};
